import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import {useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader, Divider, Grid, Select, TextField, Toolbar} from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import PlanningSummary from "./PlanningSummary";
import {Formik} from "formik";
import * as Yup from "yup";
import DialogItemWorkDetail from "./DialogItemWorkDetail";
import {Link as RouterLink} from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as Arrow } from "../../assets/images/arrow-right.svg";
import {makeStyles} from "@mui/styles";
import SettingsIcon from "@mui/icons-material/Settings";

const emails = ['username@gmail.com', 'user02@gmail.com'];
function ManageCarryScore(props) {
    const {t} = useTranslation()
    return (
        <Grid lg={12} md={12} m={0} p={2}>
            <Toolbar>
                <Typography>
                    {t('label.xxxAdd')}
                </Typography>
                <Box sx={{flex: 1}}/>
                <Button>{t('label.edit')} 5555</Button>
                <Button>X</Button>
            </Toolbar>
            <Divider/>
            <Typography>
                header
            </Typography>
            <Typography>
                header desc
            </Typography>
            <Grid container>
                <Grid item lg={4}><Card><CardContent> test </CardContent></Card></Grid>
                <Grid item lg={4}><Card><CardContent> test </CardContent></Card></Grid>
                <Grid item lg={4}><Card><CardContent> test </CardContent></Card></Grid>
            </Grid>
            <Divider/>
            <Typography>
                header
            </Typography>
            <Typography>
                header desc
            </Typography>
            <Table size="small" aria-label="purchases">
                <TableHead>
                    <TableRow>
                        <TableCell>{t('label.code')}</TableCell>
                        <TableCell>{t('label.workloadDetail')}</TableCell>
                        <TableCell>{t('label.amountOfWork')}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>itemCode</TableCell>
                        <TableCell>itemDesc</TableCell>
                        <TableCell>amount unit</TableCell>
                        <TableCell>{t('label.showDetail')}

                        <DialogItemWorkDetail/>
                        </TableCell>
                    </TableRow>
                </TableBody>
                {/*<EnhancedTable data={row.items}/>*/}
            </Table>
            <Grid item container>
                <Grid item lg={8}></Grid>
                <Grid item lg={4}> <Typography>ปริมาณงานจากระบบ xx ชั่วโมง </Typography></Grid>
            </Grid>
            <Grid item>
                <Typography>
                    (ปริมาณงานจากระบบเป็นปริมาณที่ใช้เป็นข้อมูลในการวางแผน ไม่ใช่ปริมาณรวมของภาระงานจริงที่ใช้ในการประเมิน)
                </Typography>
            </Grid>
        </Grid>
    );
}
const useStyles = makeStyles({
    btn: {
        // fontSize: "18px !important", 
        // lineHeight:"24.59px !important",
        // textDecoration: "underline !important",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
});
function SimpleDialog(props) {
    const {onClose, selectedValue, open} = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const handleListItemClick = (value) => {
        onClose(value);
    };
    return (
         <Dialog onBackdropClick={() => {return false}} onClose={handleClose} open={open} maxWidth='lg'>
            <ManageCarryScore/>
        </Dialog>
    );
}
SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
export default function DialogItemDetail(props) {
    const { id } = props;
    const classes = useStyles();
    const {t} = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };
    return (
        // <div>
        //     <Typography variant="subtitle1" component="div">
        //         Selected: {selectedValue}
        //     </Typography>
        //     <br/>
        //     <Button variant="outlined" onClick={handleClickOpen}>
        //         DialogItemDetail
        //     </Button>
        //     <SimpleDialog
        //         selectedValue={selectedValue}
        //         open={open}
        //         onClose={handleClose}
        //     />
        // </div>

    <>

        <Button
                to={`/app/workload-and-performance/${id}`}
                target="_blank"
                component={RouterLink}
                classes={{ root: classes.btn }}
                sx={{padding: "0px"}}>
            {t('label.showMoreInfo')} <Arrow />
        </Button>


        {/*<Button onClick={handleClickOpen}>{t('label.showMoreInfo')} &gt;</Button>*/}
        <SimpleDialog
            selectedValue={selectedValue}
            open={open}
            onClose={handleClose}
        />
    </>
    );
}
